import axios from 'axios';
import HomeInfo from './HomeInfo';
import Api from './reconApi';
import { getAppStore } from '../state/appStore';
import {
	presignBody,
	reconFilesUploadEnabled,
	s3PutHeaders,
	uploadWithTicket,
} from './reconFileUpload';

function currentUploadScope() {
	const appStore = getAppStore();
	const state = appStore && appStore.getState ? appStore.getState() : null;
	const site = state && state.settings_site;
	const dealerships = state && state.settings_dealerships;
	const installation = dealerships && dealerships.installation;
	const fromInstallation = installation && typeof installation.subdomain === 'string'
		? installation.subdomain
		: '';
	return {
		dealerSettings: site && site.dealer_settings,
		subdomain: fromInstallation || Api.subdomain(),
	};
}

export function reconFilesUploadOn() {
	const { dealerSettings, subdomain } = currentUploadScope();
	return reconFilesUploadEnabled({ dealerSettings, subdomain });
}

function presign(body) {
	return axios.post(`${HomeInfo.host()}file_uploads`, body, {
		headers: { 'Content-Type': 'application/json' },
	}).then(response => response.data);
}

function putFile(ticket, file, onProgress) {
	return axios.put(ticket.upload_url, file, {
		headers: s3PutHeaders(ticket.headers),
		transformRequest: [data => data],
		onUploadProgress: onProgress,
	});
}

// Null means the flag is off and the caller keeps the PHP upload.
// With the flag on, a type the API does not presign rejects. It does not fall back.
export function uploadReconFile({ kind, file, vehicleId, userId, onProgress }) {
	if (!reconFilesUploadOn()) return Promise.resolve(null);

	const body = presignBody({
		kind,
		filename: file && file.name,
		byteSize: file && file.size,
		vehicleId,
		userId,
	});
	if (!body) {
		const name = file && file.name ? file.name : 'file';
		return Promise.reject(new Error(`File type is not allowed: ${name}`));
	}

	return uploadWithTicket(
		file,
		() => presign(body),
		(ticket, data) => putFile(ticket, data, onProgress),
	);
}

export function copyReconFileFromUrl({ vehicleId, url }) {
	if (!reconFilesUploadOn()) return Promise.resolve(null);

	return axios.post(`${HomeInfo.host()}file_uploads/from_url`, {
		vehicle_id: vehicleId,
		url,
	}, {
		headers: { 'Content-Type': 'application/json' },
	}).then(response => response.data);
}
